(ns common.patterns.empty-state-view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["react" :as react]
            ["src/svg/objects/book-open.svg$default" :as BookOpen]
            [common.util :refer [spread-obj]]
            [uix.core :refer [$ defui]]))

(defui empty-state-view [{:keys [artwork title description actions docs-href sx]}]
  ($ Stack {:justifyContent "center"
            :alignItems "center"
            :gap 3
            :sx (spread-obj #js {:flex 1}
                            sx)}
     ($ artwork {:width 120 :height 120})
     ($ Stack {:gap 1
               :alignItems "center"}
        ($ Typography {:variant "h3"}
           title)
        (cond
          (string? description) ($ Typography {:width 430 :textAlign "center"}
                                   description)

          (react/isValidElement description) description))
     (when actions
       ($ Stack {:direction "row" :gap 1}
          actions))
     (when docs-href
       ($ Button {:component "a"
                  :href docs-href
                  :target "_blank"
                  :startIcon ($ BookOpen)}
          "Learn how"))))
